
import { checkVideoExixt } from '../../../services/helper';
const BannerSection = ({ data }) => {
    console.log("data", data);
    return (<section class="singlebanner" style={{backgroundImage: `url('https://adminaccess.inquirely.com/inquirely//public/uploads/${data && data.banner_image}')`}}>
    </section>)
}
export default BannerSection